import { type RepubCountry } from '@cx-web/domain-types';

import { Avatar } from '~/components/avatar/Avatar.tsx';
import { type ValueBetResult } from '~/configuration/types';
import useMedia from '~/providers/use-media';

import { trackBetTypeToolTipOpen } from '../tracking';

import { BetTypeLabel } from './BetTypeLabels/BetTypeLabels';
import styles from './styles/Profile.module.css';
import { AiBadge } from './AiBadge';

// TODO: Use CXY Profile

export type ProfileProps = {
  aiProjection?: ValueBetResult['aiProjection'];
  betName: ValueBetResult['betName'];
  line?: ValueBetResult['line'];
  lineName?: string;
  marketClassification?: ValueBetResult['marketClassification'];
  marketDisplayName: ValueBetResult['marketDisplayName'];
  marketPropType: ValueBetResult['marketPropType'];
  repubCountry?: RepubCountry;
  resourcesUrl?: string;
  sportsData: ValueBetResult['sportsData'];
  teamData?: ValueBetResult['teamData'];
  type?: ValueBetResult['type'];
};

const Profile = ({
  aiProjection,
  betName,
  line,
  lineName,
  marketClassification,
  marketDisplayName,
  marketPropType,
  repubCountry,
  resourcesUrl,
  sportsData,
  teamData,
  type,
}: ProfileProps) => {
  const mediaValues = useMedia();
  const isMobile = mediaValues?.isMobile ?? false;
  const hasAiProjection = aiProjection !== undefined && aiProjection !== null;

  const localizedLineName = line && repubCountry ? (line.nameMap?.[repubCountry] ?? line.name) : line?.name;

  return (
    <div className={styles.profile} data-testid="profile">
      <div className={styles.betDetails}>
        <Avatar
          betName={betName}
          marketClassification={marketClassification}
          marketPropType={marketPropType}
          sportsData={sportsData}
          teamData={teamData}
        />
        <div className={styles.titleCell} id="bet-name">
          {line ? (
            <>
              <h3 className={styles.titleHeading} data-testid="bet-name">
                {lineName ?? localizedLineName}
              </h3>
              <p className={styles.titleText} data-testid="bet-market">
                {line.sign} {line.absolute} {marketDisplayName}
              </p>
              {hasAiProjection && resourcesUrl && marketDisplayName && (
                <AiBadge description={marketDisplayName} projection={aiProjection} resourcesUrl={resourcesUrl} />
              )}
            </>
          ) : (
            <>
              <h3 className={styles.titleHeading} data-testid="bet-name">
                {betName}
              </h3>
              <p className={styles.titleText} data-testid="bet-market">
                {marketDisplayName}
              </p>
              {hasAiProjection && resourcesUrl && marketDisplayName && (
                <AiBadge description={marketDisplayName} projection={aiProjection} resourcesUrl={resourcesUrl} />
              )}
            </>
          )}
        </div>
      </div>
      {type && (
        <BetTypeLabel
          onOpenChange={open => {
            if (open) {
              trackBetTypeToolTipOpen({ props: type });
            }
          }}
          shouldShowLabel={false}
          side={isMobile ? 'left' : 'top'}
          type={type}
        />
      )}
    </div>
  );
};

export { Profile };
